// Typelizer digest d007e71066a5cef6c7d2b4c5c9f0c246
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /learners/schools/:school_id/school_profile/edit */
  edit: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/school_profile/edit', params, options),
    method: 'get',
  }),

  /** PATCH /learners/schools/:school_id/school_profile */
  update: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/learners/schools/:school_id/school_profile', params, options),
    method: 'patch',
  }),
}
